/**
 * Admin RBAC types — mirror backend `apps.accounts.permissions`.
 *
 * Sprint 8A B1: chỉ tận dụng existing User.role. Per-action permission matrix
 * fetch qua /api/admin/me/permissions/ (B2 sẽ implement endpoint).
 */
export type AdminAction =
  // Course
  | "course.create"
  | "course.edit"
  | "course.delete"
  | "course.publish"
  // Chốt 2026-07-13 — phân công/đổi/gỡ giảng viên phụ trách course. Chỉ
  // tenant_admin/superadmin, KHÔNG cấp cho instructor.
  | "course.assign_instructor"
  // Plan 2026-10-27 — nạp gói nội dung F-Future (.zip) vào môn. Chỉ tenant_admin/superadmin.
  | "course.import_pack"
  // Lesson
  | "lesson.create"
  | "lesson.edit"
  | "lesson.delete"
  | "lesson.reorder"
  // Quiz
  | "quiz.create"
  | "quiz.edit"
  | "quiz.delete"
  | "question.create"
  | "question.edit"
  | "question.delete"
  // Sprint 30 — chấm bài short_answer/essay + cấu hình AI-assist mode
  | "answer.grade"
  | "essay_grading.settings"
  // User
  | "user.create"
  | "user.edit"
  | "user.delete"
  | "user.invite"
  | "user.role_change"
  | "user.export"
  // Sprint 32 — import CSV/Excel gán hàng loạt sinh viên vào 1 Major
  | "user.bulk_import"
  // Major assignment
  | "major.assign"
  | "major.edit"
  | "major.remove"
  // Term offering
  | "term_offering.manage"
  // Sprint 26+ — lịch sử học phí/tín chỉ theo tenant
  | "tuition_rate.manage"
  // Curriculum — CRUD Program/Major/Term (khung chương trình đào tạo)
  | "curriculum.manage"
  // Order
  | "order.read"
  | "order.refund"
  // Audit
  | "audit.read"
  // Analytics
  | "analytics.read"
  // Plan 2026-10-03 — thông báo chung, kiểm duyệt diễn đàn, rubric, phúc khảo
  | "announcement.send"
  | "forum.moderate"
  | "rubric.manage"
  | "appeal.review";

/** Roles cho phép vào /admin/* */
export const ADMIN_ROLES = ["instructor", "tenant_admin", "superadmin"] as const;
export type AdminRole = (typeof ADMIN_ROLES)[number];

export function isAdminRole(role: string | undefined): role is AdminRole {
  return !!role && (ADMIN_ROLES as readonly string[]).includes(role);
}
